<!-- 二代网关基础信息 -->
<template>
  <div style="margin-bottom: 30px;">
    <el-table :data="list" style="height:300px">
      <el-table-column :label="$t('integration.coordinator_name')">
        <template #default="{row}">
          <i
            :class="equiStatus[row.status].icon"
            :title="$t(equiStatus[row.status].title)"
          ></i>
          {{ row.name }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('类型')" prop="type"></el-table-column>
    </el-table>

    <ConfigDialog
      :isShowConfig.sync="isShowConfig"
      :title="title"
      ref="config"
      v-bind="$attrs"
      :rowData="rowData"
      coordinator
    ></ConfigDialog>
  </div>
</template>

<script>
import { equiStatus } from '@/utils/convert'

import ConfigDialog from '@/pages/equipment/gateway/modal/ConfigDialog/ConfigDialog.vue'
import bus from '@/utils/bus'

export default {
  props: {
    list: {}
  },
  components: {
    ConfigDialog
  },
  data () {
    return {
      equiStatus,
      isShowConfig: false,
      title: $t('integration.configuration_information'),
      rowData: {}
    }
  },
  methods: {
    setting (row) {
      this.rowData = row

      this.isShowConfig = true
    },
    detail (row) {
      bus.$emit('coordinatorParam', row.id, row.name, { coordinator: true })
    }
  }
}
</script>
